export function formatReferenceNumber(
  sequence: number,
  issueCategory: string | null | undefined,
  categoryAbbreviations: Record<string, string>,
): string {
  const category = issueCategory?.trim()
  const configured = category ? categoryAbbreviations[category] : undefined
  const abbreviation = (configured ?? category ?? 'GEN')
    .replace(/[^a-z0-9]/gi, '')
    .slice(0, 3)
    .toUpperCase()
    .padEnd(3, 'X')

  return `AQ-${abbreviation}-${String(sequence).padStart(4, '0')}`
}
